"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MessageAddOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M27,3H5A3,3,0,0,0,2,6V19a3,3,0,0,0,3,3H8v6a1,1,0,0,0,.08.38,1,1,0,0,0,.54.54.94.94,0,0,0,.76,0,1,1,0,0,0,.33-.21L16.41,22H27a3,3,0,0,0,3-3V6A3,3,0,0,0,27,3Zm1,3V19h0a1,1,0,0,1-1,1H16a1,1,0,0,0-.71.3L10,25.59h0V22h0a2,2,0,0,0-2-2H5a1,1,0,0,1-1-1H4V6H4A1,1,0,0,1,5,5H27a1,1,0,0,1,1,1Z"/><path d="M20,11.5H17v-3a1,1,0,0,0-2,0v3H12a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0v-3h3a1,1,0,0,0,0-2Z"/>';
var MessageAddOutlineSVG = function MessageAddOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.MessageAddOutlineSVG = MessageAddOutlineSVG;
MessageAddOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MessageAddOutlineSVG);
exports.default = _default;